export const getRequestId = (orderId: string) => {
  const firstPart = orderId.substring(0, 4);
  const lastPart = orderId.substring(orderId.length - 4);

  return firstPart + lastPart;
};
